import { useEffect, useRef } from "react";
import { FiX } from "react-icons/fi";
import useChatStore from "../../store/chatStore";
import { getInitials, formatLastSeen } from "../../utils/helpers";
import styles from "./MemberProfilePopup.module.css";

const MemberProfilePopup = ({ member, anchorRect, onClose }) => {
  const { onlineUsers } = useChatStore();
  const popupRef = useRef(null);
  const isOnline = onlineUsers.includes(member?._id);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  if (!member) return null;

  // Position popup near the anchor (avatar/name)
  const style = {};
  if (anchorRect) {
    const top = Math.min(anchorRect.bottom + 8, window.innerHeight - 260);
    const left = Math.min(anchorRect.left, window.innerWidth - 260);
    style.top = top;
    style.left = Math.max(8, left);
  }

  return (
    <div className={styles.popup} ref={popupRef} style={style}>
      <button className={styles.closeBtn} onClick={onClose}><FiX size={13} /></button>

      {/* Avatar */}
      <div className={styles.avatarWrap}>
        <div className={styles.avatar}>
          {member.avatar
            ? <img src={member.avatar} alt={member.name} className={styles.avatarImg} />
            : <span className={styles.initials}>{getInitials(member.name)}</span>}
        </div>
        <span className={`${styles.dot} ${isOnline ? styles.dotOnline : styles.dotOffline}`} />
      </div>

      <div className={styles.name}>{member.name}</div>

      <div className={`${styles.status} ${isOnline ? styles.statusOnline : styles.statusOffline}`}>
        {isOnline ? "● Online" : member.lastSeen ? `Last seen ${formatLastSeen(member.lastSeen)}` : "Offline"}
      </div>

      {member.bio && (
        <div className={styles.bio}>{member.bio}</div>
      )}

      {member.email && (
        <div className={styles.email}>{member.email}</div>
      )}
    </div>
  );
};

export default MemberProfilePopup;
